<template>
    <div id="new_core_waybill" v-if="is_initialized">
        <div v-if="!is_get_core_waybill_number">
            <div v-if="partitions.length">
                <div
                    class="ui segment blue"
                    v-for="(partitions_group, key) in partitions_group_by_customer_identity"
                >
                    <h5 v-if="key != 'null'">
                        {{
                            $store.getters['provider/core_waybills_module/customer'](
                                key
                            ).company_name || "-"
                        }}
                    </h5>

                    <div class="ui doubling two column grid">
                        <div class="column pointer"
                            v-for="partition in partitions_group"
                            @click="set_current_partition(partition)"
                            @dblclick="fetch_core_waybill_number_by_partition()"
                            >
                            <div class="ui center aligned segment"
                                :class="{active: current_partition.identity == partition.identity}"
                                >
                                <div class="ui mini statistic">
                                    <div class="value">
                                        <span :data-tooltip="'字軌'" :data-position="'bottom left'">
                                            {{ partition.prefix }}
                                        </span>
                                        <span style="text-decoration: underline;">
                                            <span :data-tooltip="$t('ui.pages.core_waybills.partition_number_from')" :data-position="'bottom center'">
                                                {{ partition.numbers_from }}
                                            </span>
                                            <span> ~ </span>
                                            <span :data-tooltip="$t('ui.pages.core_waybills.partition_number_to')" :data-position="'bottom center'">
                                                {{ partition.numbers_to }}
                                            </span>
                                        </span>
                                    </div>
                                    <div class="label">
                                        {{ partition.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="ui center aligned segment">
                    <h3 v-if="!current_partition.identity">
                        {{ $t('ui.pages.core_waybills.please_select_partition') }}
                    </h3>
                    <div v-else>
                        <button class="ui basic blue button"
                            @click="fetch_core_waybill_number_by_partition()">
                            {{ $t('ui.page_titles.new_core_waybill') }}
                        </button>
                    </div>
                </div>

            </div>
            <div v-else class="ui red raised segment center aligned">
                <h2>
                    {{ $t('ui.pages.core_waybills.errors.no_anything_partitions_can_use') }}
                </h2>
            </div>
        </div>
        <div v-else>
            <div class="ui right floated basic red button"
                style="margin: 6px 0;"
                @click="undo()"
                >
                {{ $t('ui.pages.core_waybills.back_to_select_partition') }}
            </div>
            <div class="clear">
            </div>
            <div class="ui negative message" v-if="create_core_waybill_error">
                <div class="header">
                    {{ $t('ui.pages.core_waybills.create_core_waybill_error') }}
                </div>
                <p>
                    {{ create_core_waybill_error }}
                </p>
            </div>

            <CoreWaybill
                :core_waybill="core_waybill"
                :template="'detail'"
                :is_auto_print="false"
                :is_can_update="true"
                :is_can_print_label="false"
                :is_show_change_template_btns="false"
                :active_button="tool_core_waybill_active_button"
                :detail="{
                    is_show_receipt_file: false,
                    is_show_partition: false,
                    is_show_statuses: false,
                }"

            >
            </CoreWaybill>
        </div>
    </div>
</template>

<script>
import CoreWaybill from '@toolbox/core_waybill/main.vue'

export default {
    name: "NewCoreWaybill",
    components: {
        CoreWaybill
    },
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,

            partitions: [],
            current_partition: {},
            partitions_group_by_customer_identity: {},

            core_waybill: {},
            is_get_core_waybill_number: false,
            tool_core_waybill_active_button: {
                content: this.$t('ui.general.create'),
                channel: "tool_core_waybill_create_channel"
            },

            create_core_waybill_error: "",
        }
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off("tool_core_waybill_create_channel")
        this.$bus.$on("tool_core_waybill_create_channel", () => {
            this.create_core_waybill()
        })
    },
    watch: {
    },
    computed: {
    },
    methods: {
        undo() {
            this.is_get_core_waybill_number = false
            this.create_core_waybill_error = ""
            this.core_waybill = {}
        },
        async init() {
            await this.fetch_partitions()
            await this.fetch_associated_partitions()
            await this.fetch_customers()
            await new Promise(resolve => {
                this.is_initialized = true
            })
        },
        fetch_partitions() {
            var rest_url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_partitions)
            var url = rest_url.parse(
                {},
                "?pagination=false"
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.partitions = this.partitions.concat(response.data.partitions)
                    } else {
                        // this.$noty.error('取得號碼區間 失敗', response.data.error)
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.partitions'),
                                reason: ': ' + response.data.error
                            })
                        )
                        return Promise.reject(response.data.error)
                    }
                })
        },
        fetch_associated_partitions() {
            var rest_url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_associated_partitions)
            var url = rest_url.parse(
                {},
                "?pagination=false"
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.partitions = this.partitions.concat(response.data.associated_partitions)
                    } else {
                        // this.$noty.error('取得號碼區間 失敗', response.data.error)
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('ui.page_titles.associated_partitions'),
                                reason: ': ' + response.data.error
                            })
                        )
                        return Promise.reject(response.data.error)
                    }
                })
        },
        fetch_customers() {
            this.partitions_group_by_customer_identity = _.groupBy(this.partitions, "customer_identity")
            _.forEach(this.partitions_group_by_customer_identity, (value, key) => {
                if (key != 'null') {
                    this.$store.dispatch('provider/core_waybills_module/fetch_customer', {
                        customer_identity: key
                    })
                }
            })

            return Promise.resolve()
        },
        fetch_core_waybill_number_by_partition() {
            var rest_url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_partition_get_usable_numbers)
            var url = rest_url.parse(
                {
                    partition_identity: this.current_partition.identity,
                    amount: 1
                }
            )

            axios.get(
                url,
                {
                    headers: { Authorization: localStorage.getItem("authentication_token") }
                }
            ).then(response => {
                if (response.data.status == "success") {
                    this.core_waybill = {
                        number: response.data.usable_numbers[0],
                        material_identity: this.current_partition.material_identity,
                        partition_identity: this.current_partition.identity,
                        is_used: true,
                        original_number: null,
                        tracking_number: null,
                        sender_company_name: null,
                        sender_address: null,
                        sender_name: null,
                        sender_phone: null,
                        sender_email: null,
                        sender_url: null,
                        sender_fax: null,
                        consignee_company_name: null,
                        consignee_address: null,
                        consignee_name: null,
                        consignee_phone: null,
                        consignee_email: null,
                        consignee_fax: null,
                        temperature: null,
                        goods_name: null,
                        flight_number: null,
                        note: null,
                        note_2: null,
                        note_3: null,
                        serial: 1,
                        pieces: 1,
                        payment_type: null,
                        measurement: null,
                        weight_in_kilo: null,
                        receipt_file_url: null,
                        is_collected: 0,
                        collection: null,
                        collection_fee: 0,
                        simplified_declaration_form_fee: 0,
                        declaration_form_fee: 0,
                        declaration_form_extra_fee: 0,
                        tax: 0,
                        price: 0,
                        insurance: 0,
                        material_fee: 0,
                        consignee_tax_point: 0,
                        sender_tax_point: 0,
                        warehouse_fee: 0,
                        fuel_surcharge: 0,
                        value_added_service_fee: 0,
                        overlength_fee: 0,
                        overweight_fee: 0,
                        extra_fee: 0,
                        shipping_date: null,
                        shipping_period: null,
                        shipping_note: null,
                        cvs_store_number: null,
                        cvs_store_name: null,
                        cvs_store_address: null,
                        cvs_store_phone: null,
                        station_code: null,
                        declared_valu: null
                    }
                    this.is_get_core_waybill_number = true
                } else {
                    // this.$noty.error('取得運單號碼 失敗')
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.attributes.core_waybills.number')
                        })
                    )
                }
            })
            .catch(error => {
                // this.$noty.error('取得運單號碼 異常')
                this.$noty.error(
                    this.$t('ui.notifications.error.fetch__name', {
                        name: this.$t('models.attributes.core_waybills.number')
                    })
                )
            })
        },
        set_current_partition(partition) {
            this.current_partition = {}
            this.current_partition = partition
        },
        create_core_waybill() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybills_create).parse(
                {}
            )
            return axios.post(url, this.core_waybill, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        // this.$noty.success('建立運單成功')
                        this.$noty.success(
                            this.$t('ui.notifications.success.create__name', {
                                name: this.$t('models.core_waybills')
                            })
                        )
                        this.$router.push({name: 'edit_core_waybill', params: {
                            identity: response.data.core_waybill.identity
                        }})
                    } else {
                        // this.$noty.error('建立運單 失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.create__name', {
                                name: this.$t('models.core_waybills'),
                                reason: ": " + response.data.errors
                            })
                        )
                        this.create_core_waybill_error = response.data.errors
                    }

                    return Promise.reject(response.data.errors)
                })
        },
    },
}
</script>
<style scoped lang="scss">
    .segment.active {
        border: 3px solid rgb(232, 149, 77);
    }
</style>
